export type UserActivityLogTabsType = {[key: string]: string};
export const TABS: UserActivityLogTabsType = {
    BULK_ACTIVITY: 'BULK_ACTIVITY',
};
